'use client';

import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren, useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import { GetUser } from '@/src/lib/auth/types';
import { eventBus } from '@/src/lib/core/event/bus';
import { EventBusName } from '@/src/lib/core/event/types';
import { Customer, UserStatus } from '@/src/lib/customer/types';
import { Dictionary } from '@/src/lib/dictionary/types';
import { useSearchParams } from 'next/navigation';
import RegisterForm from '@/src/app/components/RegisterForm/RegisterForm';
import { DeserializedStore } from '@/src/lib/store/types';
import { Register } from '@/src/types/register';
import { ServerActionResult } from '@/src/lib/http/types';
import { SingleApiFormat } from '@/src/lib/http/jsonapi/deserializer';
type RegisterModalBlockerProps = PropsWithChildren<{
  dict: Dictionary;
  userInfo: GetUser;
  store: DeserializedStore;
  registerFormSubmit: (data: Register.RequestPayload) => Promise<ServerActionResult<SingleApiFormat<Customer>, null> | ServerActionResult<null, string>>;
  lang: string;
  country: string;
}>;
function RegisterModalBlockerClient(t0) {
  const $ = _c(15);
  const {
    children,
    dict,
    userInfo,
    store,
    registerFormSubmit,
    lang,
    country
  } = t0;
  const searchParams = useSearchParams();
  const [displayRegisterModal, setDisplayRegisterModal] = useState(userInfo.userStatus === UserStatus.UNREGISTERED);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function closeRegisterModal() {
      setDisplayRegisterModal(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeRegisterModal = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function openRegisterModal() {
      setDisplayRegisterModal(true);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const openRegisterModal = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      eventBus.on(EventBusName.CHECKOUT_CLICK_OPEN_REGISTER_MODAL, openRegisterModal);
      eventBus.on(EventBusName.CLOSE_REGISTER_MODAL_BLOCKER, closeRegisterModal);
      return () => {
        eventBus.off(EventBusName.CHECKOUT_CLICK_OPEN_REGISTER_MODAL, openRegisterModal);
        eventBus.off(EventBusName.CLOSE_REGISTER_MODAL_BLOCKER, closeRegisterModal);
      };
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  if (searchParams?.get("showRegisterForm") === "false") {
    return null;
  }
  let t5;
  if ($[4] !== country || $[5] !== dict || $[6] !== displayRegisterModal || $[7] !== lang || $[8] !== registerFormSubmit || $[9] !== store || $[10] !== userInfo) {
    t5 = displayRegisterModal ? <Modal lang={lang} country={country} dict={dict} onModalClose={() => setDisplayRegisterModal(false)} open={true} size="large"><RegisterForm user={userInfo} dict={dict} store={store} onSubmit={registerFormSubmit} lang={lang} /></Modal> : null;
    $[4] = country;
    $[5] = dict;
    $[6] = displayRegisterModal;
    $[7] = lang;
    $[8] = registerFormSubmit;
    $[9] = store;
    $[10] = userInfo;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== t5) {
    t6 = <>{t5}{children}</>;
    $[12] = children;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
export default RegisterModalBlockerClient;